import { Box, Skeleton } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const SkeletonProductSourcingSettings = () => {
    const { t } = useTranslation();

    return (
        <Box>
            <Skeleton
                width="300px"
                height="32px"
                sx={{ marginBottom: '20px' }}
            />
            <Skeleton width="90%" height="30px" />
            {/* <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    marginTop: '40px',
                }}
            >
                <Skeleton
                    variant="rectangular"
                    sx={{
                        width: '100%',
                        maxWidth: '420px',
                        borderRadius: '12px',
                        height: '400px',
                        marginRight: '40px',
                    }}
                />
                <Skeleton
                    variant="rectangular"
                    sx={{
                        width: '100%',
                        maxWidth: '520px',
                        borderRadius: '12px',
                        height: '400px',
                    }}
                />
            </Box> */}
        </Box>
    );
};
